<template>
  <div class="orderlist">
    <ul>
      <li v-for="(item, index) of odList" :key="index">
        <router-link :to="{ name: 'Order', query: { typeId: item.typeId } }">
          <div class="icon"><img :src="item.icon" /></div>
          <div class="name">
            <p>{{ item.name }}</p>
          </div>
        </router-link>
      </li>
    </ul>
    <ul>
      <li v-for="(item2, index2) of adList" :key="index2">
        <router-link :to="{ name: item2.path }">
          <div class="icon"><img :src="item2.icon" /></div>
          <div class="name">
            <p>{{ item2.name }}</p>
          </div>
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script>
import { orderType } from '@/utils/orderType'

export default {
  data () {
    return {
      odList: [
        { name: '待付款', icon: require('../../../assets/icon/ad1.png'), typeId: orderType('待付款').id },
        { name: '待发货', icon: require('../../../assets/icon/ad2.png'), typeId: orderType('待发货').id },
        { name: '待收货', icon: require('../../../assets/icon/ad3.png'), typeId: orderType('待收货').id },
        { name: '退换记录', icon: require('../../../assets/icon/ad4.png'), typeId: orderType('售后').id }
      ],
      adList: [
        { name: '收货地址', icon: require('../../../assets/icon/od1.png'), path: 'Myaddress', },
        { name: '订单记录', icon: require('../../../assets/icon/od2.png'), path: 'orderhistory', },
        { name: '客服热线', icon: require('../../../assets/icon/service.png'), path: 'service' },
         { name: '我的钱包', icon: require('../../../assets/icon/wallet.png'), path: 'Wallet' }
        // { name: '余额记录', icon: require('../../../assets/icon/od3.png'), path: '', },
        // { name: '我的福利', icon: require('../../../assets/icon/od4.png'), path: 'welfare', }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.orderlist {
  font-size: 0.26rem;
  width: 7.18rem;
  border-radius: 10px;
  margin: auto;
  margin-top: 0.2rem;
  background: white;
  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 1.05rem;
      margin: 0.3rem 0.37rem;
      text-align: center;
      img {
        width: 0.47rem;
        height: 0.47rem;
      }
      p {
        margin: 0.1rem 0;
      }
      a {
        color: #666666;
      }
    }
  }
}
</style>